import React from "react";
import axios from "axios";

export const ApplicationByIdApi = async (token,id) => {
  try {
    let url = `https://visapro-api.tcore.online/api/v1/applications/${id}`;

    const response = await axios.get(url,{
        headers: {
            'Authorization': `Bearer ${token}` 
          },
    });
    const application = {
      data: response.data,
    };
    return application;
  } catch (error) {
    const application = {
      error: error,
    };
    return application;
  }
};
